import React from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Input from "../../../component-lib/Atoms/Input/Input";
import Button from "../../../component-lib/Molecules/button/Button";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import { DRUG_CATALOGUE_DATA } from "../constants";
import BootstrapDialog from "../../../utils/bootstrap-dialog-style/BootstrapDialog";

interface DrugCatalogueDialogProps {
  isOpen: boolean;
  handleData: (data: any) => void;
  handleClose: () => void;
  isEdit?: boolean;
  defaultDrugData: any;
}

export default function DrugCatalogueDialog({
  isOpen = false,
  handleClose,
  handleData,
  isEdit = false,
  defaultDrugData,
}: DrugCatalogueDialogProps) {
  const dialogHeading = isEdit ? "Edit Drug" : "Add Drug";
  const validationSchema = Yup.object().shape({
    [DRUG_CATALOGUE_DATA?.DRUG_TYPE]: Yup.string().required(
      "Drug catalogue is required"
    ),

    [DRUG_CATALOGUE_DATA?.DRUG_TYPE]: Yup.string().required(
      "Drug type is required"
    ),
  });

  return (
    <BootstrapDialog
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <Formik
        initialValues={{
          [DRUG_CATALOGUE_DATA?.DRUG_TYPE]: `${defaultDrugData?.drugtype || ""}`,
          [DRUG_CATALOGUE_DATA?.DRUG_NAME]: `${defaultDrugData?.drugName || ""}`,
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          try {
            // getFormData(values);
            handleData(values);
          } catch (error) {
            console.log(error);
          } finally {
            setSubmitting(false); // Reset submitting state
          }
        }}
      >
        {({
          errors,
          values,
          touched,
          isValid,
          dirty,
          setFieldValue,
          handleBlur,
          handleSubmit,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <DialogTitle
                sx={{
                  m: 0,
                  p: 2,
                  fontWeight: 600,
                  fontSize: "18px",
                  fontFamily: "inter",
                }}
                id="customized-dialog-title"
              >
                {dialogHeading}
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
              <hr />
              {/* MAIN CONTENT */}
              <DialogContent>
                {/* <div className="pt-4">
                    <EventEHRUploadImageCard
                      imageUrl={null}
                      handleImage={(data) => {}}
                    />
                  </div> */}

                <div
                  style={{
                    // height: deviceType === "mobile" ? "40vh" : "fit-content",
                    overflow: "auto",
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: "16px",
                  }}
                >
                  <div className="pt-4">
                    <Input
                      textFieldLabel="Drug Type"
                      // placeholder=""
                      size="small"
                      name={DRUG_CATALOGUE_DATA.DRUG_TYPE}
                      value={values[DRUG_CATALOGUE_DATA.DRUG_TYPE]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          DRUG_CATALOGUE_DATA.DRUG_TYPE,
                          e.target.value
                        );
                      }}
                      onBlur={handleBlur}
                      error={
                        touched[DRUG_CATALOGUE_DATA.DRUG_TYPE] &&
                        Boolean(errors[DRUG_CATALOGUE_DATA.DRUG_TYPE])
                      }
                      helperText={
                        touched[DRUG_CATALOGUE_DATA.DRUG_TYPE]
                          ? errors[DRUG_CATALOGUE_DATA.DRUG_TYPE]
                          : undefined
                      }
                    />
                  </div>

                  <Input
                    textFieldLabel="Drug Name"
                    // placeholder=""
                    size="small"
                    name={DRUG_CATALOGUE_DATA.DRUG_NAME}
                    value={values[DRUG_CATALOGUE_DATA.DRUG_NAME]}
                    onChangeCb={(e) => {
                      setFieldValue(
                        DRUG_CATALOGUE_DATA.DRUG_NAME,
                        e.target.value
                      );
                    }}
                    onBlur={handleBlur}
                    error={
                      touched[DRUG_CATALOGUE_DATA.DRUG_NAME] &&
                      Boolean(errors[DRUG_CATALOGUE_DATA.DRUG_NAME])
                    }
                    helperText={
                      touched[DRUG_CATALOGUE_DATA.DRUG_NAME]
                        ? errors[DRUG_CATALOGUE_DATA.DRUG_NAME]
                        : undefined
                    }
                  />
                </div>
              </DialogContent>

              {/* ACTION BUTTON */}
              <DialogActions style={{ padding: "24px" }}>
                {/* <div className="flex justify-end mt-10 gap-4"> */}
                {isEdit && (
                  <Button
                    label={TEXT_CONSTANTS?.CANCEL}
                    variant="outlined"
                    onClickCb={handleClose}
                    style={{
                      width: "120px",
                      height: "44px",
                      padding: "12px 20px",
                      fontSize: "16px",
                      backgroundColor: "white",
                      border: "none",
                      color: "#393939",
                    }}
                  />
                )}
                <Button
                  //   disabled={!isValid} // Button disabled if form is invalid or submitting
                  type="submit"
                  label={TEXT_CONSTANTS?.SAVE}
                  variant="contained"
                  onClickCb={() => {}}
                  style={{
                    width: "200px",
                    height: "44px",
                    padding: "12px 20px",
                    fontSize: "16px",
                  }}
                ></Button>
                {/* </div> */}
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </BootstrapDialog>
  );
}
